import { render, staticRenderFns } from "./u-pagination-outlined-tile.vue?vue&type=template&id=6fee88bc&scoped=true&"
import script from "./u-pagination-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-pagination-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee88bc",
  null
  
)

export default component.exports